import { Tab, TabList, Tabs } from "@chakra-ui/react";
import { ReactElement } from "react";

interface CustomTagsProps {
    solidDeselected?:boolean;
    name:string
    value:number;
    onChange:(v:number) => void;
    choices:string[]|ReactElement[];
    w?:string;
}


const CustomTabsFilled = ({name,value,onChange,choices,w}:CustomTagsProps) => {
    return <Tabs variant='soft-rounded' index={value} onChange={onChange} size='sm' w={w ?? undefined}>
        <TabList 
            gap='6px' h='40px' alignItems='center'
            p='0 4px' bg='#F5F7F9' borderRadius='20px'
        >
            {choices.map((v:string|ReactElement,i:number) => {
                return <Tab key={`${name}-${i}`}
                    fontWeight='400'
                    h='32px'
                    color='#171C22'
                    _hover={{ bg:'#F5F7F9' }}
                    _active={{ bg:'#d8d9dd' }}
                    _selected={{
                        bg:'#171C22',
                        color:'white'
                    }}
                >
                    {v}
                </Tab>
            })}
        </TabList>
    </Tabs>
}


export default CustomTabsFilled;